"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delegateTokens = void 0;

var _tokens = require("./../../tokens");

const delegateTokens = elements => class BasisTheoryTokensElementsDelegate extends _tokens.BasisTheoryTokens {
  create(payload, requestOptions) {
    if (elements !== null && elements !== void 0 && elements.hasElement(payload)) {
      return elements.tokens.create(payload, requestOptions);
    }

    return super.create(payload, requestOptions);
  }

  update(id, payload, requestOptions) {
    if (elements !== null && elements !== void 0 && elements.hasElement(payload)) {
      return elements.tokens.update(id, payload, requestOptions);
    }

    return super.update(id, payload, requestOptions);
  }

  retrieve(id, requestOptions) {
    if (elements !== undefined) {
      return elements.tokens.retrieve(id, requestOptions);
    }

    return super.retrieve(id, requestOptions);
  }

};

exports.delegateTokens = delegateTokens;